import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'

export const CATEGORY_ALL = 'all'

export type TInvestorCategory = ESecondCategories | typeof CATEGORY_ALL

export const CATEGORY_BY_SLUG: Record<string, ESecondCategories> = {
  current: ESecondCategories.CURRENT_REPORT,
  annual: ESecondCategories.YEAR_REPORT,
  semiAnnual: ESecondCategories.HALF_YEAR_REPORT,
  quarterly: ESecondCategories.QUARTER_REPORT,
  ordinaryAssembly: ESecondCategories.ORDINARY_ASSEMBLY,
  extraOrdinaryAssembly: ESecondCategories.EXTRAORDINARY_ASSEMBLY,
}
